// Maths Types
// Used in frontend for math / geometry / coordinate based types

// Alignment Types
export const AlignmentTypes = {
  // Horizontal
  left: 'left',
  center: 'center',
  right: 'right',

  // Vertical
  top: 'top',
  middle: 'middle',
  bottom: 'bottom'
}
export const AlignmentTypeLookup = [
  { name: 'Left', value: AlignmentTypes.left },
  { name: 'Center', value: AlignmentTypes.center },
  { name: 'Right', value: AlignmentTypes.right },

  { name: 'Top', value: AlignmentTypes.top },
  { name: 'Middle', value: AlignmentTypes.middle },
  { name: 'Bottom', value: AlignmentTypes.bottom },
]

// Hole Measure Points
export const HoleMeasurePointTypes = {
  // Horizontal
  left: 'left',
  center: 'center',
  right: 'right',

  // Vertical
  top: 'top',
  middle: 'middle',
  bottom: 'bottom'
}
export const HoleMeasurePointTypeLookup = [
  { name: 'Left', value: HoleMeasurePointTypes.left },
  { name: 'Center', value: HoleMeasurePointTypes.center },
  { name: 'Right', value: HoleMeasurePointTypes.right },
  { name: 'Top', value: HoleMeasurePointTypes.top },
  { name: 'Middle', value: HoleMeasurePointTypes.middle },
  { name: 'Bottom', value: HoleMeasurePointTypes.bottom },
]

// Geometry Segment types
export const SegmentTypes = {
  line: 'line',
  arc: 'arc'
}

// Edge types
export const EdgeTypes = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left'
}

// Axis Types
export const AxisTypes = {
  horizontal: 'horizontal',
  vertical: 'vertical'
}
export const AxisTypeLookup = [
  { name: 'Horizontal', value: AxisTypes.horizontal },
  { name: 'Vertical', value: AxisTypes.vertical }
]